import {registerTemplateGraphNode} from "#template/template-node/register"
import {pointGeometryAttributeLike, pointGeometryAttributeLikeMarker} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {PointGeometryAttributeLikeNode} from "#template/nodes/geometry-graph/attribute/attribute-node"

import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {CastOperatorParameters} from "#template/nodes/geometry-graph/attribute/cast-operator/geometry-cast-operator-node"
import {GeometryCastOperatorNode, castOperatorParametersSchema} from "#template/nodes/geometry-graph/attribute/cast-operator/geometry-cast-operator-node"

export type PointGeometryCastOperatorParameters = CastOperatorParameters<PointGeometryAttributeLikeNode>

const definition: TemplateNodeDefinition<PointGeometryCastOperatorParameters> = {
    nodeClass: "PointGeometryCastOperator",
    validation: {
        parameters: castOperatorParametersSchema(pointGeometryAttributeLike),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class PointGeometryCastOperator extends GeometryCastOperatorNode<0, PointGeometryAttributeLikeNode> implements PointGeometryAttributeLikeNode {
    get [pointGeometryAttributeLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }
}
